export const LEAN_COMPONENTS_TRANSLATION_KEY_PREFIX = 'lct';
export const PANEL_TYPE_MANAGED_OPTIONS = 'managedOptions';
export const PANEL_TYPE_SLOT = 'slot_selection';
//# sourceMappingURL=constants.js.map